import { IS_NODE } from "@/__main__/constants.mjs";
import { devWarn } from "@/util/dev.mjs";

export function normalizeRegion(region = "") {
  return region?.toLowerCase() || "";
}

export function isDerivedRiotID(derivedRiotID) {
  return (
    derivedRiotID &&
    derivedRiotID.includes("-") &&
    derivedRiotID.split("-")?.[1]?.length !== 0
  );
}

export function separateDerivedRiotID(derivedRiotID) {
  if (!derivedRiotID) throw new Error("Invalid Riot ID");
  const [gameName, tagLine] = derivedRiotID.split("-");
  // if (!gameName || !tagLine) throw new Error("Not Derived Riot ID");
  return [gameName, tagLine];
}

export function getDerivedId(region, name, gameName, tagLine) {
  if (!region) {
    return name;
    // throw new Error("Region is required");
  }

  if (isDerivedRiotID(name)) {
    [gameName, tagLine] = separateDerivedRiotID(name);
  }

  if (gameName && tagLine) {
    return `${normalizeRegion(region)}:${getDerivedRiotID(gameName, tagLine)}`;
  }

  if (!name) {
    return null;
    // throw new Error("Either Game Name + Tag Line or Summoner Name is required");
  }

  return !region ? name : `${normalizeRegion(region)}:${name}`;
}

export function getDerivedRiotID(gameName, tagLine) {
  if (!gameName || !tagLine) {
    const msg = IS_NODE
      ? `Game Name + Tag Line required, got "${gameName}", "${tagLine}"`
      : "Game Name + Tag Line required";
    throw new Error(msg);
  }
  return `${gameName}-${tagLine}`;
}

export function extractRegionFromDerivedId(derivedId) {
  return derivedId?.match(/^(.*?):/)?.[1] ?? "";
}

export function getDerivedIdFromSummoner(summoner) {
  if (!summoner) {
    devWarn("can not get derived id from empty value");
    return;
  }
  const { region, internalName, gameName, tagLine } = summoner;
  return getDerivedId(region, internalName, gameName, tagLine);
}

export function getSummonerFromDerivedId(derivedId) {
  const region = extractRegionFromDerivedId(derivedId);
  const name = extractNameFromDerivedId(derivedId);
  return [region, name];
}

export function extractNameFromDerivedId(derivedId) {
  return derivedId?.match(/^(?:.*?):(.*)$/)?.[1] ?? "";
}
